// The one status chip of a flagged issue (ADR-0034): the same colour, icon and words wherever an issue appears — the Action center, the
// history, the issue page and its explainer, the workpaper page, the chat, Overview and Home. Colour is never the only signal: the icon
// and the text say it too (the token pairs keep the contrast in light and dark). Everything shown is the engine's chip (lib/issues chipOf).
import { ISSUE_STATE, chipIcon, chipKind, chipOf, chipText, type IssueChip } from "../lib/issues";

export const CHIP_CLS: Record<string, string> = {
  done: "border-done-line bg-done-bg text-done", progress: "border-progress-line bg-progress-bg text-progress", waiting: "border-waiting-line bg-waiting-bg text-waiting",
  blocked: "border-blocked-line bg-blocked-bg text-blocked", neutral: "border-neutral-line bg-neutral-bg text-neutral",
};

/** A count of issues in one state (Overview, Home), in the same colour, icon and words as the chip. */
export function IssueStateCount({ state, count, label }: { state: string; count: number; label?: string }) {
  const meta = ISSUE_STATE[state] ?? ISSUE_STATE.open;
  return (
    <span data-issue-state={state} data-status={meta.kind}
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded border px-1.5 py-0.5 text-xs font-medium ${CHIP_CLS[meta.kind]}`}>
      <span aria-hidden="true">{meta.icon}</span><span className="tabular-nums">{count}</span> {label ?? meta.label}
    </span>
  );
}

type HasStatus = { status?: string | null; closed_as?: string | null; status_label?: string | null; chip?: IssueChip | null; state?: string | null };

/** `issue` is anything carrying an issue's status (an issue, an Action center row's issue, a related issue); or pass the `chip` itself. */
export function IssueStatusChip({ issue, chip, className = "" }: { issue?: HasStatus | null; chip?: IssueChip | null; className?: string }) {
  const c = chip ?? chipOf(issue ?? {});
  const text = chipText(c);
  const title = c.updated ? `Updated ${c.updated.at.slice(0, 10)} by ${c.updated.by}: ${c.updated.note}` : undefined;
  return (
    <span data-issue-state={c.state} data-status={chipKind(c)} title={title}
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded border px-1.5 py-0.5 text-xs font-medium ${CHIP_CLS[chipKind(c)]} ${className}`}>
      <span aria-hidden="true">{chipIcon(c)}</span>{text}
    </span>
  );
}
